const modelNameExtractor = model => {
  return model._modelName;
};

export default modelNameExtractor;
